/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetProjectCountryDto
 */
export interface GetProjectCountryDto {
    /**
     * 
     * @type {string}
     * @memberof GetProjectCountryDto
     */
    id: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetProjectCountryDto
     */
    countryDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetProjectCountryDto
     */
    countryDictionaryId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectCountryDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetProjectCountryDto interface.
 */
export function instanceOfGetProjectCountryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "countryDictionary" in value;
    isInstance = isInstance && "countryDictionaryId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetProjectCountryDtoFromJSON(json: any): GetProjectCountryDto {
    return GetProjectCountryDtoFromJSONTyped(json, false);
}

export function GetProjectCountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectCountryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'countryDictionary': GetDictionaryDtoFromJSON(json['countryDictionary']),
        'countryDictionaryId': json['countryDictionaryId'],
        'active': json['active'],
    };
}

export function GetProjectCountryDtoToJSON(value?: GetProjectCountryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'countryDictionary': GetDictionaryDtoToJSON(value.countryDictionary),
        'countryDictionaryId': value.countryDictionaryId,
        'active': value.active,
    };
}

